import TwistedNavigation from '../TwistedShirts/TwistNav/TwistedNavigation';
import ShoppingBag from "./ShoppingBag/ShoppingBag";

const Bag = () => {
    return (
        <>
            <TwistedNavigation />
            <ShoppingBag />
        </>
    )
}

export default Bag;